var $todd = require("./support");
import { Element, Class } from "@webhare-system/frameworks/mootools/core";

// ---------------------------------------------------------------------------
//
// Iframe
//

/*// Mootools support - support 'message' as native event, and add source & data to DOMEvent
if (Element.NativeEvents.message != 2)
{
  Element.NativeEvents.message = 2;
  $wh.extendDOMEventConstructor(
    function(event)
    {
      this.source = event.source || null;
      this.data = event.data || null;
    });
}
*/
$todd.ObjIFrame = new Class(
{ Extends: $todd.ObjLayout
, componenttype: "iframe"

  // ---------------------------------------------------------------------------
  //
  // Variables
  //

  /// List of added components
, addcomps: []

  /// Whether the frame has been loaded
, loaded: false

  /// List of queued calls
, queuedmessages: []

  /// Submit data
, data: null

  /// Zoom factor (percentage)
, zoom: 100

  // ---------------------------------------------------------------------------
  //
  // Init
  //

, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parent(parentcomp, data, replacingcomp);

    this.node = new Element("t-iframe", { "data-name": this.name
                                        });
    this.iframe = new Element("iframe"
                             , { marginWidth: 0
                               , marginHeight: 0
                               , frameBorder: 0
                               , src: this.calcFrameSourceUri(data)
                               , events:
                                   { load: this.gotIFrameLoad.bind(this)
                                  }
                             }).inject(this.node);
    this.node.store("todd", this);

    if(data.addcomps)
      this.setAdditionalComponents(data.addcomps);
    this.data = data.data;
    this.setZoom(data.zoom);

    this.selectionflags = [];

    window.addEventListener('message', this.gotWindowMessage.bind(this));
  }

  // ---------------------------------------------------------------------------
  //
  // Helper stuff
  //

, setAdditionalComponents: function(componentnames)
  {
    for (var i = 0; i < componentnames.length; ++i)
      this.addcomps.include(this.owner.addComponent(this, componentnames[i]));
  }

, calcFrameSourceUri: function(data)
  {
    var uri = data.mainuri ? data.mainuri + (data.fragment?'#'+data.fragment:'') : '';
    if(!uri)
      uri = 'about:blank';
    return uri;
  }

, postQueuedMessages: function(resenddata)
  {
    if (!this.loaded)
      return;

    if (!this.iframe.contentWindow)
    {
      this.loaded = false;
      return;
    }

    if (resenddata)
    {
      this.iframe.contentWindow.postMessage(
        { type: 'data'
        , data: this.data
        }, '*');
    }

    while (this.queuedmessages.length)
    {
      var msg = this.queuedmessages.shift();

      if(msg.type == "print")
        this.iframe.contentWindow.setTimeout("window.print()", 10);
      else if(msg.type == "calljs")
      {
        var cmd = 'window[' + JSON.stringify(msg.funcname) + '].apply(window, ' + JSON.stringify(msg.args) + ')';
        this.iframe.contentWindow.eval(cmd);
      }
      else
        this.iframe.contentWindow.postMessage(msg, '*');
    }
  }

, setZoom: function(zoom)
  {
    if (!zoom)
      return;
    // Limit zoom to max factor 10x
    zoom = Math.min(Math.max(zoom, 10), 1000);
    if (!isNaN(zoom) && zoom != this.zoom)
    {
      this.zoom = zoom;
      this.relayout();
    }
  }

  // ---------------------------------------------------------------------------
  //
  // Layouting
  //
, calculateDimWidth: function()
  {
    this.width.min = 32;
  }

, calculateDimHeight: function()
  {
    this.height.min = 32;
  }

, relayout: function()
  {
    this.node.setStyles({"width": this.width.set
                        ,"height": this.height.set
                        });
    var zoomfactor = (this.zoom / 100);
    this.iframe.setStyles({ "transform": "scale(" + zoomfactor + ")"
                          , "width": Math.round(100.0 / zoomfactor) + "%"
                          , "height": Math.round(100.0 / zoomfactor) + "%"
                          });
    if (this.width.set != this.prevwidth || this.height.set != this.prevheight)
    {
      this.prevwidth = this.width.set;
      this.prevheight = this.height.set;
      this.queuedmessages.push({ type: 'resize' });
      this.postQueuedMessages(false);
    }
  }

  // ---------------------------------------------------------------------------
  //
  // Callbacks & updates
  //

, applyUpdate: function(data)
  {
    switch(data.type)
    {
      case 'eventmask':
        this.unmasked_events = data.unmasked_events;
        return;
      case 'content':
        this.iframe.src = this.calcFrameSourceUri(data);
        this.loaded = false;
        return;
      case 'addcomps':
        this.setAdditionalComponents(data.addcomps);
        return;
      case 'data':
        this.data = data.data;
        this.postQueuedMessages(true);
        return;
      case 'zoom':
        this.setZoom(data.zoom);
        return;
    }

    this.parent(data);
  }

, getSubmitValue: function()
  {
    return this.data;
  }

, enabledOn: function(checkflags, min, max, selectionmatch)
  {
    return $todd.Screen.checkEnabledFlags(this.selectionflags, checkflags, min, max, selectionmatch);
  }

, addIframeEvent:function(obj, type, fn)
  {
    try
    {
      if(obj.addEventListener)
      {
        obj.addEventListener(type, fn, false);
      }
      else
      {
        //replace 'fn' with a wrapper that will invoke it with an event
        fn = function() { return fn.apply(this, [window.event]); };
        obj.attachEvent('on'+type, fn);
      }
    }
    catch(e)
    {

    }
  }

, gotIFrameLoad: function()
  {
    this.loaded = true;
    this.postQueuedMessages(true);

    try
    {
      var doc = this.iframe.contentWindow.document;
      this.addIframeEvent(doc, "click", this.clickLink.bind(this));
    }
    catch(e)
    {
      //its okay if it fails... we probably weren't intended to control the dialog (FIXME we should just ensure ALL iframes load todd-iframe.js or just wrap all iframes inside a local parent with which we can postmessage)
    }
  }
, clickLink:function(e)
  {
    var anchor = e.target;
    while(anchor && anchor.nodeName && !['A'].contains(anchor.nodeName.toUpperCase()))
      anchor = anchor.parentNode;
    if(!anchor)
      return true; //not a link, let it pass
    //ADDME Let anchorlinks etc pass ?

    if(this.isEventUnmasked('clicklink'))
      this.queueMessage('clicklink', {href:anchor.href}, true);
    else
      window.open(anchor.href, '_blank');

    if(e.preventDefault)
      e.preventDefault();
    return false; //cancel the event
  }

, gotToddIframeInitialized: function(toddiframe)
  {
    this.toddiframe = toddiframe;
  }

, gotWindowMessage: function(event)
  {
    // Only accept messages from our iframe
    if (! (this.iframe.contentWindow && event.source == this.iframe.contentWindow))
      return;

    var data=event.data;
    switch (data.type)
    {
      case 'callback':
        this.queueMessage('callback', { parameters: data.data }, false);
        break;

      case 'data':
        if (typeof data.data == "object")
        {
          this.data = data.data;
          this.queueMessage('data', { data: data.data }, false);
        }
        else
          console.error('IFrame "' + this.name + '" sent non-object value:', data.data);
        break;

      case 'contextmenu':
        var menu = this.owner.getComponent(data.name);
        if(!menu)
          return;

        var iframepos = this.node.getPosition(document.body);
        menu.openMenuAt(iframepos.x + data.x, iframepos.y + data.y);
        break;

      case 'actionenabler':
        this.selectionflags = data.selectionflags || [];
        this.owner.actionEnabler();
        break;
    }
  }

, onMsgJS:function(data)
  {
    this.queuedmessages.push({ type: 'calljs', funcname: data.funcname, args: data.args });
    this.postQueuedMessages(false);
  }

, onMsgCallback:function(data)
  {
    this.queuedmessages.push({ type: 'callback', data: data });
    this.postQueuedMessages(false);
  }

, onMsgPrint:function()
  {
    this.queuedmessages.push({ type: 'print' });
    this.postQueuedMessages(false);
  }
});


// ---------------------------------------------------------------------------
//
// Registration
//

exports.components = { iframe: $todd.ObjIFrame };



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/iframe.es